import React from 'react'
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  CircularProgress,
} from '@mui/material'
import {
  SmokingRooms as SmokingIcon,
  Star as StarIcon,
  TrendingUp as TrendingIcon,
} from '@mui/icons-material'
import { useGetHistorySummaryQuery } from '@store/api/historyApi'
import { formatAverageRatingDisplay } from '@utils/statDisplay'

const HistorySummary: React.FC = () => {
  const { data: summary, isLoading } = useGetHistorySummaryQuery()

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" py={2}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  if (!summary) return null

  return (
    <Grid container spacing={2} mb={3}>
      <Grid item xs={12} sm={4}>
        <Card variant="outlined">
          <CardContent sx={{ textAlign: 'center' }}>
            <SmokingIcon color="primary" sx={{ fontSize: 32, mb: 0.5 }} />
            <Typography variant="h4" fontWeight={700}>
              {summary.totalSmoked}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Total Cigars Smoked
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Card variant="outlined">
          <CardContent sx={{ textAlign: 'center' }}>
            <StarIcon color="warning" sx={{ fontSize: 32, mb: 0.5 }} />
            <Typography variant="h4" fontWeight={700}>
              {formatAverageRatingDisplay(summary.averageRating)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Average Rating
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Card variant="outlined">
          <CardContent sx={{ textAlign: 'center' }}>
            <TrendingIcon color="success" sx={{ fontSize: 32, mb: 0.5 }} />
            <Typography variant="body2" color="text.secondary" mb={1}>
              Top Brands
            </Typography>
            {summary.topBrands.length > 0 ? (
              <Box display="flex" flexWrap="wrap" gap={0.5} justifyContent="center">
                {summary.topBrands.map((brand) => (
                  <Chip
                    key={brand.id}
                    label={`${brand.name} (${brand.count})`}
                    size="small"
                    color="primary"
                    variant="outlined"
                  />
                ))}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No data yet
              </Typography>
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default HistorySummary
